<template>
  <div class="card" @click="onClick(actionObject.topic)" :class="{ 'card--small': small }">
    <img class="card__icon" src="@/assets/pi.svg" v-if="actionObject.topic==='math'">
    <img class="card__icon" src="@/assets/sport.svg" v-if="actionObject.topic==='sport'">
    <img class="card__icon" src="@/assets/game.svg" v-if="actionObject.topic==='fun'">
    <img class="card__icon" src="@/assets/energy.svg" v-if="actionObject.topic==='sleep'">
    <img class="card__icon" src="@/assets/cheese.svg" v-if="actionObject.topic==='french'">
    <img class="card__icon" src="@/assets/game.svg" v-if="actionObject.topic==='gaming'">
    <span class="card__label">{{description}}</span>
  </div>
</template>

<script>

export default {
  name: "ActionCard",
  props: {
    actionObject: Object,
    onClick: Function,
    small: {
      default: false
    }
  },
  data() {
    return {};
  },

  computed: {
    description() {
      switch(this.actionObject.topic) {
        case "math": {
          if(this.actionObject.style === "exam") {
            return "Math exam";
          } else if(this.actionObject.style === "school") {
            return "Math class";
          } else {
            return "Study math";
          }
        }
        case "french":
          if(this.actionObject.style === "exam") {
            return "French exam";
          } else if(this.actionObject.style === "school") {
            return "French class";
          }
          return "Study french";
        case "sport":
          if(this.actionObject.style === "exam") {
            return "Sport exam";
          } else if(this.actionObject.style === "school") {
            return "School class";
          }
          return "Make sports";
        case "gaming":
          return "Play game";
        case "sleep":
          return "Sleep";
        case "chill":
          return "";
      }
      return "";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.card {
  width: 10vw;
  height: 14vw;
  max-width: 100%;
  max-height: 100%;
  background-image: url('../assets/card.svg');
  background-size: contain;
  background-repeat: no-repeat;
  color: black;

  display: grid;
  grid-template-rows: 60px 30px;
  grid-row-gap: 8px;
  align-items: center;
  justify-items: center;
  padding: 2vh 0;

  $parent: &;

  &--small {
    padding: 10px 0;
    grid-template-rows: 40px 20px;
    grid-row-gap: 5px;

    #{$parent}__icon {
      width: 30px;
    }

    #{$parent}__label {
      font-size: 1rem;
    }
  }

  &__icon {
    width: 60px;
    max-width: 5vw;
  }

  &__label {
    font-size: 1.8vw;
    text-align: center;
    max-width: 80%;
    line-height: 1.0;
  }


}

@media only screen and (max-width: 1023px) {
  .card__label {
    display: none;
  }

  .card {
    padding: 0;
    width: 15vh;
    height: 20vh;

    &__icon {
      width: 30px;
      max-width: 5vw;
    }

    $parent: &;

    &--small {
      padding: 0;
      padding-top: 2vh;
      grid-template-rows: 40px 0;
      grid-row-gap: 0;

      #{$parent}__icon {
        width: 7vh;
      }

      #{$parent}__label {
        font-size: 1rem;
      }
    }
  }

}
</style>
